// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1CUXQ","inputDescription":"styles_inputDescription__19M5Q"};